export default "__VITE_ASSET__21dac804__"